module.exports = __webpack_public_path__ + "static/media/UB_logotyp_2rader_gra_RGB.7ed85a3f.png";